import { Injectable, inject } from '@angular/core';
import {
  LoggedInDetails,
  MilesLabel,
  SessionTimeOutModelContent,
  SignupLoginContent,
  ToolTipToggle
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AppConfigService,
  ApplicationConfig,
  AuxiliaryNavigationAemItem,
  CookieHelperService,
  DashboardResponse,
  HeaderFooterMachCoreContentService,
  LoggedInMilesAem,
  LoggingService,
  UserDataService,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginFacadeHelperSuperService {
  signupLoginContent$ = new BehaviorSubject<SignupLoginContent>(
    {} as SignupLoginContent
  );

  sessionTimeOutContent$ = new BehaviorSubject<SessionTimeOutModelContent>(
    {} as SessionTimeOutModelContent
  );

  isLoggedIn$ = new BehaviorSubject<boolean>(false);
  isWarmState$ = new BehaviorSubject<boolean>(false);
  isReady$ = new BehaviorSubject<boolean>(false);
  loggedInDetails$ = new BehaviorSubject<LoggedInDetails>(
    {} as LoggedInDetails
  );

  toolTipToggle$ = new BehaviorSubject<ToolTipToggle>({} as ToolTipToggle);

  protected contentService: HeaderFooterMachCoreContentService = inject(
    HeaderFooterMachCoreContentService
  );

  protected loggingService: LoggingService = inject(LoggingService);
  protected loginArr: AuxiliaryNavigationAemItem[] = [];
  protected APP_NAME = '';
  userSession: UserSessionService = inject(UserSessionService);
  _config: ApplicationConfig = inject(ApplicationConfig);
  cookieHelper: CookieHelperService = inject(CookieHelperService);
  userData: UserDataService = inject(UserDataService);
  appConfigService = inject(AppConfigService);
  milesLabelContent: LoggedInMilesAem = {} as LoggedInMilesAem;

  showSessionTimeoutModal = false;
  isBusiness = false;
  loginLink = '';
  loginLabel = '';
  signupLabel = '';
  signupLink = '';
  milesLabel: MilesLabel = {} as MilesLabel;
  tooltipLoginContent = '';
  tooltipSignUpContent = '';
  hideAccountRecoveryTooltip = false;
  tooltipUserIdentifier = '';
  APP_SESS_TIME_OUT = 0;
  mfaToolTipDisplayPages: string[] = [];
  tooltipAccountRecoveryContent: {
    label: string;
    header: string;
    linkLabel: string;
    link: string;
  } = {
    label: '',
    header: '',
    linkLabel: '',
    link: ''
  };

  checkLoggedIn(res: DashboardResponse): boolean {
    return res.loggedIn === true || this.isWarmState$.getValue() === true;
  }

  setIsBusiness(accountCookie: string | null | undefined): void {
    if (accountCookie && accountCookie.length) {
      const accountCookieJson = JSON.parse(accountCookie);
      if (accountCookieJson['isBusiness']) {
        this.isBusiness = true;
      }
    }
  }
}
